import { ReactElement } from "react";
import { createReducer, createStandardAction } from "typesafe-actions";

export interface Notification {
  id: string;
  message: ReactElement | string;
  dismiss: number | "NOT_DISMISSIBLE" | "USER_ONLY";
  type: "error" | "success" | "info" | "beta";
  persistThroughNav?: boolean;
}

export const addNotification = createStandardAction("ADD_NOTIFICATION")<
  Notification
>();
export const removeNotification = createStandardAction("REMOVE_NOTIFICATION")<
  string
>();
export const clearNotifications = createStandardAction("CLEAR_NOTIFICATIONS")();
export const clearNotificationsOnNav = createStandardAction(
  "CLEAR_NOTIFICATIONS_ON_NAV"
)();

export type NotificationState = Record<string, Notification>;

export const defaultNotificationState: NotificationState = {};

export const NotificationReducer = createReducer(defaultNotificationState)
  .handleAction(addNotification, (state, action) => ({
    ...state,
    [action.payload.id]: action.payload
  }))
  .handleAction(removeNotification, (state, action) =>
    Object.keys(state).reduce((newState: NotificationState, key: string) => {
      if (key !== action.payload) {
        newState[key] = state[key];
      }
      return newState;
    }, {} as NotificationState)
  )
  .handleAction(clearNotificationsOnNav, state =>
    Object.keys(state)
      .filter(key => state[key]?.persistThroughNav)
      .reduce((newState, key) => {
        newState[key] = state[key];
        return newState;
      }, {} as NotificationState)
  )
  .handleAction(clearNotifications, _ => defaultNotificationState);
